import { Redirect } from "react-router-dom";

import { useState } from 'react';
import { useSelector } from 'react-redux'
import { authSelector } from '../store';
import { authProvider } from '../auth';
import { useTranslation } from 'react-i18next';
import TelegramLoginButton from '../Components/TelegramLoginButton';


function LoginPage() {
  const { t } = useTranslation();
  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState();
  const auth = useSelector(authSelector);

  const submitLogin = (e) => {
    e.preventDefault();
    authProvider.login(username, password, (res) => {
      if (res) {
        setErrorMessage("");
      } else {
        setErrorMessage("Can not login using provided credentials!");
      }
    });
  };

  if (auth) {
    return <Redirect to="/" />;
  }

  return (
    <div className="page-content">
      <div className="page-content-inner">
        <div className="uk-width-1-3@m m-auto" style={{ paddingTop: '48px', paddingBottom: '48px' }}>
          <div
            style={{
              background: 'var(--card-bg, #fff)',
              borderRadius: '12px',
              boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
              padding: '36px 40px',
            }}
          >
            <div className="mb-4" style={{ textAlign: 'center' }}>
              <div style={{ marginBottom: '12px' }}>
                <span style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '52px',
                  height: '52px',
                  borderRadius: '50%',
                  background: 'rgba(var(--color-primary-rgb, 29, 161, 242), 0.1)',
                }}>
                  <i className="icon-feather-user" style={{ fontSize: '22px', color: 'var(--color-primary, #1da1f2)' }}></i>
                </span>
              </div>
              <h2 className="mb-0" style={{ fontSize: '22px', fontWeight: '700' }}>{t("login.welcome")}</h2>
              <p className="my-0" style={{ color: 'var(--text-secondary, #6b7280)', fontSize: '14px', marginTop: '4px' }}>{t("login.description")}</p>
            </div>

            <form onSubmit={submitLogin}>
              {errorMessage && <div className="alert alert-danger" role="alert">{errorMessage}</div>}

              <div className="uk-form-group">
                <label className="uk-form-label">{t("fields.username")}</label>
                <div className="uk-position-relative w-100">
                  <span className="uk-form-icon">
                    <i className="icon-feather-mail"></i>
                  </span>
                  <input className="uk-input" id="username" type="text" placeholder="username" value={username} onChange={(e) => setUserName(e.target.value)} />
                </div>
              </div>

              <div className="uk-form-group">
                <label className="uk-form-label">{t("fields.password")}</label>
                <div className="uk-position-relative w-100">
                  <span className="uk-form-icon">
                    <i className="icon-feather-lock"></i>
                  </span>
                  <input className="uk-input" type="password" placeholder="••••••••" value={password} onChange={(e) => setPassword(e.target.value)} />
                </div>
              </div>

              <button
                type="submit"
                className="btn btn-default"
                style={{ width: '100%', marginTop: '4px' }}
              >
                {t("buttons.login")}
              </button>
            </form>

            <TelegramLoginButton />
          </div>
        </div>
      </div>
    </div>
  )
}

export default LoginPage;
